import React, { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import McqResultCard from "./McqResultCard";
Chart.register(...registerables);

const DifficultyChart = ({ data, assessmentIsAdaptive, studentResultData }) => {
  const canvasRef = useRef(null);
  let chartInstance = useRef(null);
  const [open, setOpen] = React.useState(false);
  const [selectedPoint, setSelectedPoint] = React.useState(null);
  useEffect(() => {
    // Destroy previous chart instance before creating a new one
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = canvasRef.current.getContext("2d");
    const totalScore = studentResultData?.assessment?.isAdaptive
      ? Number(studentResultData?.ability ?? 0)
      : Number(studentResultData?.assessment?.total_marks ?? 0);

    const values = (data?.values || [])
      .map(v => Number(v))
      .filter(v => !isNaN(v));


    const minY = values.length
      ? Math.floor(Math.min(0, ...values))
      : 0;

    const maxY = Math.ceil(
      Math.max(totalScore, ...(values.length ? values : [0]))
    );
    console.log("values:", values);
    console.log("ability:", studentResultData?.ability);
    console.log("minY:", minY, "maxY:", maxY);

    chartInstance.current = new Chart(ctx, {
      type: "line",
      data: {
        labels: data?.labels,
        datasets: [
          {
            label: assessmentIsAdaptive ? "Ability Score Path" : "Score Path",
            data: values,
            backgroundColor: "#4635B1",
            borderColor: "#4635B1",
            borderWidth: 3,
            pointBackgroundColor: data?.isCorrect?.map((status) => {
              if (status === "correct") return "#00b050";
              if (status === "partial") return "#ed7d31";
              return "#c00000";
            }),
            pointRadius: 6,
          },
        ],
      },
      options: {
        responsive: true,
        scales: {
          x: {
            type: "category",
            grid: {
              color: "rgba(0, 0, 0, 0.5)",
            },
            ticks: {
              color: "black",
            },
          },
          y: {
            type: "linear",
            min: minY,
            max: maxY,
            ticks: {
              stepSize: 1, // Set a smaller step size for more detailed tick marks
              callback: function (value) {
                return value.toFixed(1); // Display as decimal (e.g., 0.5, 1.0, 1.5, etc.)
              },
            },
            grid: {
              color: "rgba(0, 0, 0, 0.4)",
            },
          },
        },
        onClick: (event, elements) => {
          if (elements.length > 0) {
            const { index, datasetIndex } = elements[0];
            const clickedData = {
              label: data.labels[index],
              value: values[index],
              isCorrect: data.isCorrect[index],
              data: data.data[index],
              isDescriptive: data.isDescriptive[index],
              teacherComment: data.teacherComments[index],
            };
            setSelectedPoint(clickedData);
            setOpen(true);
          }
        },
      },
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  return (
    <>
      <canvas
        ref={canvasRef}
        style={{
          width: "950px",
          maxHeight: "400px",
        }}
      ></canvas>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ m: 0, p: 2, ml: 1, color: "#f97e00" }}>
          Question Detail
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpen(false);
              setSelectedPoint(null);
            }}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedPoint ? (
            <>
              <McqResultCard
                assessmentIsAdaptive={assessmentIsAdaptive}
                value={selectedPoint.value}
                data={selectedPoint.data}
                isCorrect={selectedPoint.isCorrect}
                label={selectedPoint.label}
                isDescriptive={selectedPoint.isDescriptive}
                teacherComment={selectedPoint.teacherComment}
              />
            </>
          ) : (
            <Typography>No data available</Typography>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DifficultyChart;
